import * as React from 'react'
import PropTypes from 'prop-types'

import {
  Container,
  TextContainer,
  GreenText
} from
'./style'

const ArticleBlockSimpleCaps = ({
  text = ''
}) => {
  return (
    <Container>
      <TextContainer>
        <GreenText className='uppercase'>
          { text }
        </GreenText>
      </TextContainer>
    </Container>
  )
}

ArticleBlockSimpleCaps.propTypes = {
  text: PropTypes.string
}

export default ArticleBlockSimpleCaps
